import { Link } from 'react-router-dom';
import { exclusiveScoop } from '@/mocks/home';

export default function ExclusiveScoopSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto relative">
        <div className="relative bg-foreground-950 rounded-3xl overflow-visible">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-[42%] relative -mt-10 lg:-mt-12 lg:-ml-8 mb-6 lg:mb-0">
              <div className="w-64 h-80 md:w-72 md:h-96 mx-auto lg:mx-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20portrait%20of%20smartphone%20screen%20glowing%20in%20darkness%20with%20breaking%20news%20alert%20in%20warm%20amber%20and%20red%20tones%2C%20cinematic%20noir%20photography%20style%2C%20intense%20moody%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20rich%20shadows%20and%20warm%20highlights%2C%20elegant%20composition%2C%20mysterious%20investigative%20journalism%20aesthetic&width=600&height=800&seq=scoop-featured-51cg&orientation=portrait"
                  alt="独家爆料焦点"
                  title="51吃瓜网独家爆料 - 网红塌房内幕"
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            </div>

            <div className="lg:w-[58%] px-6 md:px-10 py-8 md:py-12 lg:py-14">
              <div className="text-accent-500/30 text-7xl md:text-9xl font-heading leading-none mb-2">
                &ldquo;
              </div>
              <p className="text-lg md:text-xl text-background-50 leading-relaxed max-w-lg">
                {exclusiveScoop.quote}
              </p>
              <div className="mt-8">
                <p className="text-sm font-semibold text-background-50">
                  {exclusiveScoop.source}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">
                  {exclusiveScoop.sourceRole}
                </p>
              </div>
              <Link
                to="/article/wanghong-ta-fang-jingren-neimu"
                className="mt-8 inline-flex items-center px-6 py-3 text-sm font-semibold text-foreground-950 bg-accent-400 rounded-full hover:bg-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {exclusiveScoop.ctaLabel}
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute -top-8 -left-4 w-24 h-32 hidden lg:block pointer-events-none">
          <svg viewBox="0 0 100 140" className="w-full h-full text-foreground-800/10">
            <path
              d="M10 130 Q30 100 20 70 Q15 40 40 20 Q60 5 80 25 Q95 45 85 65 Q70 80 50 70 Q35 60 40 45"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              className="opacity-50"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}